<template>
  <div style="margin-left: 15px; ">
    <div class="row">
      <div v-if="user.id" class="py-4 px-4 col-lg-6" style="background-color: var(--corelightcolor); border-right: 15px solid white; background-color: var(--bootstrapgrey); margin-bottom: 15px;">
        <app-targets :user="user"></app-targets>
      </div>
      <div v-if="user.id" class="p-4 col-lg-6" style="background-color: #5e8dad; border-right: 15px solid white; background-color: var(--bootstrapgrey); margin-bottom: 15px;">
        <app-quotes :user="user"></app-quotes>
      </div>
    </div>
    <div class="row" style="">
      <div class="col-lg-9">
        <div class="row">
          <!-- <div class="col-lg-6 py-4 px-4" style="background-color: #8b9dc3;"> -->
          <!-- <div class="col-lg-6 py-4 px-4" style="background-color: #a8e6cf;"> -->
          <!-- <div class="col-lg-6 py-4 px-4" style="background-color: #add6ff; border-right: 15px solid white; margin-bottom: 15px;"> -->
          <div v-if="user.id" class="col-lg-6 py-4 px-4" style="background-color: var(--skyblue); border-right: 15px solid white; margin-bottom: 15px;">
            <!-- <h2>You have no workout planned for today!</h2> -->
            <app-today :user="user"></app-today>
          </div>
          <!-- <div class="col-lg-6 py-4 px-4" style="background-color: #ffefd7; border-right: 15px solid white; margin-bottom: 15px;"> -->
          <!-- <div class="col-lg-6 py-4 px-4" style="background-color: #add6ff; border-right: 15px solid white; margin-bottom: 15px;"> -->
          <div v-if="user.id" class="col-lg-6 py-4 px-4" style="background-color: var(--skyblue); border-right: 15px solid white; margin-bottom: 15px;">
            <app-weather :user="user"></app-weather>
          </div>
        </div>
        <div class="row">
          <div v-if="user.id" class="col-lg-12">
            <!-- <app-streaks></app-streaks> -->
            <app-streaks2 :user="user"></app-streaks2>
          </div>
        </div>
      </div>
      <div v-if="user.id" class="col-lg-3 p-4" style="background-color: var(--skyblue); border-right: 15px solid white;">
        <app-pb :user="user"></app-pb>
      </div>
    </div>
  </div>
</template>

<script>
  import Quotes from './Quotes.vue';
  import Targets from './TargetRaces.vue';
  import PB from './PersonalBests.vue';
  import Today from './TodaysWorkout.vue';
  import Weather from './Weather.vue';
  import Streaks from './Streaks.vue';
  import Streaks2 from './Streaks2.vue';

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  import axios from 'axios'

  export default {
    props: ['userID'],
    data () {
      return {
        user: {},
        showTargetRaceForm: true,
      }
    },
    components: {
      appQuotes: Quotes,
      appTargets: Targets,
      appPb: PB,
      appToday: Today,
      appWeather: Weather,
      appStreaks: Streaks,
      appStreaks2: Streaks2,
    },
    created () {
      this.loadDashboard()
    },
    methods: {
      loadDashboard () {
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },1500)

        console.log('Getting User Profile')
        // axios.get('/api/users/?id='+this.$store.getters.userID)
        //   .then(res => {
        //     console.log(res)
        //     this.user = res.data
        //   })
        //   .catch(error => {
        //     console.log(error)
        //   })
        // this.$store.dispatch('getUser').then(() => { // Lecture 360
        //   this.user = this.$store.getters.user
        // })
        // userID is a prop, the idea being that it can be passed in via the coach's dashboard or elsewhere to view anyone's training plan
        // If it's not passed in, then we just get the training plan of whoever is logged in
        if (!this.userID) {
          this.$store.dispatch('getUser').then(() => { // Lecture 360
            this.user = this.$store.getters.user
            console.log(this.$store.getters.user)
          })
        }
        else {
          axios.get('/api/users/?id='.concat(this.userID))
            .then(res => {
              this.user = res.data[0]
            })
            .catch(error => console.log(error))
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/myrundash/dashboard/Dashboard.vue